import request from '@/utils/request'
import base from "@/api/base";

export default {
    // 前台样衣发布
    save: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/product/saveProduct`, params),
    // 前台样衣发布草稿箱
    cgx: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/product/getDraftList`, params),
    // 前台样衣删除草稿箱
    del: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/product/deleteProduct`, params),
}